<template>
    <div
        class="locale-font">
        <div class="breadcrumb-container">
            <v-breadcrumbs :items="breadcrumbsItem"></v-breadcrumbs>
        </div>
        <h1 class="head-line-page mb-5">
            {{ breadcrumbsItem[1].text }}
        </h1>
        <div class="container-info">
            <v-card class="profile-card">
                <p class="content-header">
                    {{ this.$vuetify.lang.t('$vuetify.blacklist.profile') }}
                </p>
                <div class="d-flex">
                    <div class="upload-container">
                        <upload-image
                            ref="uploadImage"
                            :img="imgProfile(blacklistData.image)"
                            :isEditing="false"
                            :canDelete="false">
                        </upload-image>
                    </div>
                    <div class="profile-container">
                        <v-row class="mb-4">
                            <v-col cols="6">
                                <div class="label-profile">
                                    {{ this.$vuetify.lang.t('$vuetify.blacklistForm.name') }}
                                </div>
                                <div class="data-profile">
                                    {{ blacklistData.first_name }}
                                </div>
                            </v-col>
                            <v-col cols="6">
                                <div class="label-profile">
                                    {{ this.$vuetify.lang.t('$vuetify.blacklistForm.surname') }}
                                </div>
                                <div class="data-profile">
                                    {{ blacklistData.last_name }}
                                </div>
                            </v-col>
                        </v-row>
                        <div class="mb-4">
                            <div class="label-profile">
                                {{ this.$vuetify.lang.t('$vuetify.blacklistForm.reasonShown') }}
                            </div>
                            <div class="data-profile">
                                {{ blacklistData.reason === null ? '-' : blacklistData.reason }}
                            </div>
                        </div>
                        <div>
                            <div class="label-profile mb-2">
                                {{ this.$vuetify.lang.t('$vuetify.blacklistForm.status') }}
                            </div>
                            <div :class="statusInfo.style">
                                {{ statusInfo.text }}
                            </div>
                        </div>
                    </div>
                </div>
            </v-card>
            <div class="activity-log-card">
                <activity-log :logItems="blacklistActivity" />
            </div>
        </div>
    </div>
</template>

<script>
import ActivityLog from '@/components/ActivityLog.vue'
import UploadImage from '@/components/UploadImage'
import profileDefault from '@/assets/user_default.png'
export default {
    name: 'BlacklistInfo',

    components: {
        ActivityLog,
        UploadImage
    },

    data () {
        return {
            blacklistId: null,
            blacklistData: {},
            blacklistActivity: []
        }
    },

    computed: {
        breadcrumbsItem () {
            return [
                {
                    text: this.$vuetify.lang.t('$vuetify.blacklist.blacklist'),
                    disabled: false,
                    exact: true,
                    to: {
                        name: 'Blacklist'
                    }
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.blacklist.viewBlacklistProfile'),
                    disabled: true
                }
            ]
        },

        statusInfo () {
            const key = this.blacklistData.status === 'ACT' ? 'active' : 'inactive'
            return {
                text: this.$vuetify.lang.t(`$vuetify.toggleStatus.${key}`),
                style: `blacklist-status ${key}`
            }
        }
    },

    methods: {
        async getBlacklistInfo () {
            const res = await this.axios.get(`blacklist/${this.blacklistId}`)
            if (res && res.data && res.data.status === 'ok') {
                this.blacklistData = res.data.msg
            } else {
                this.$router.push({ name: 'Blacklist' }, () => {})
            }
        },

        async getBlacklistActivity () {
            const res = await this.axios.get(`blacklist/activity-log/${this.blacklistId}`)
            if (res && res.data && res.data.status === 'ok') {
                this.blacklistActivity = res.data.data
            }
        },

        imgProfile (img) {
            if (img) {
                return img
            } else {
                return profileDefault
            }
        }
    },

    async mounted () {
        this.blacklistId = this.$route.params.id
        this.$store.dispatch('setLoading', true)
        await this.getBlacklistInfo()
        await this.getBlacklistActivity()
        this.$store.dispatch('setLoading', false)
    },

    watch: {
        '$vuetify.lang.current': {
            handler: async function (after, before) {
                this.$store.dispatch('setLoading', true)
                await this.getBlacklistInfo()
                await this.getBlacklistActivity()
                this.$store.dispatch('setLoading', false)
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
    .container-info {
        display: flex;
        justify-content: space-between;
    }

    .profile-card {
        width: 55%;
        padding: 36px 54px;
        border-radius: 15px;
    }

    .activity-log-card {
        width: 40%;
    }

    .label-profile {
        color: #6c6c6c;
        font-size: 14px;
        font-weight: normal;
    }

    .blacklist-status {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 120px;
        height: 40px;
        border-radius: 40px;
        font-family: LexendDeca;
        font-size: 18px;
        font-weight: normal;
        color: white;

        &.active {
            background-color: #6c98ba;
        }
        &.inactive {
            background-color: #ff544a;
        }
    }

    .data-profile {
        font-size: 16px;
        font-weight: normal;
        color: #131410;
        font-family: 'Roboto';
    }

    .upload-container {
        min-width: 160px;
        width: 30%;
    }

    .profile-container {
        width: 70%;
    }

    ::v-deep .breadcrumb-container .v-breadcrumbs {
        padding-bottom: 18px;
    }
</style>
